<div *ngIf="files && files.length === 0">
	<div class="container" cassDragNDrop (fileDropped)="onFileDropped($event)">
		<input type="file" #fileDropRef id="fileDropRef" [multiple]="isMultiple" (change)="fileBrowseHandler($event)" />
		<h3>
			{{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.DRAG_N_DROP' | translate }}
			<br> {{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.OR' | translate }}
		</h3>
		<div>
			<button mat-stroked-button>{{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION_BUTTON_LABELS.CHOOSE_FILE' | translate }}</button>
		</div>
	</div>
	<div class="find-material-button">
		<button mat-stroked-button color="primary" (click)="emitFindMaterialClickEvent($event)">
			<span>
				{{ 'ORDER_BASKET.FIND_MATERIAL_DIALOG.ACTION_BUTTON_LABELS.FIND_MATERIAL' | translate }}
			</span>
		</button>
	</div>
</div>
<div class="files-list">
	<ng-container *ngFor="let file of files; let i = index">
		<div class="single-file">
			<div class="file-info">
				<div class="info">
					<h4 class="name">
						{{ file?.name }}
					</h4>
					<p class="size">
						{{ formatBytes(file?.size) }}
					</p>
				</div>
				<div class="button-container">
					<button mat-stroked-button
							[disabled]="!!progress"
							(click)="emitUploadFile(i)">
						<mat-icon color="primary">upload</mat-icon>
						{{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION_BUTTON_LABELS.UPLOAD' | translate }}
					</button>
					<button mat-stroked-button
							[disabled]="!!progress"
							(click)="deleteFile(i)">
						<mat-icon color="warn">delete</mat-icon>
						{{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION_BUTTON_LABELS.REMOVE' | translate }}
					</button>
				</div>
			</div>
			<div *ngIf="progress">
				<mat-progress-bar [mode]="progressBarMode" [value]="progress"></mat-progress-bar>
			</div>
			<div class="progress-label" *ngIf="progress && progressLabelKey">{{ progressLabelKey | translate }}</div>
		</div>
	</ng-container>
</div>
